var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.031,
    height: 16.647,
    viewBox: "0 0 21.031 16.647",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17071",
    "data-name": "Group 17071",
    transform: "translate(14915.031 -7070)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38135",
    "data-name": "Path 38135",
    d: "M4.532,17.181c0,.961.008,1.92,0,2.879a.938.938,0,1,1-1.876.013c-.005-.881-.008-1.762,0-2.643a.286.286,0,0,0-.227-.334,3.571,3.571,0,0,1-.012-6.762.306.306,0,0,0,.241-.355q-.009-4.479,0-8.959A.937.937,0,0,1,3.907.059a.957.957,0,0,1,.624.966q0,2.423,0,4.846c0,1.371,0,2.741,0,4.112a.291.291,0,0,0,.226.337,3.576,3.576,0,0,1-.022,6.78C4.671,17.123,4.609,17.15,4.532,17.181ZM5.3,13.709a1.714,1.714,0,1,0-1.72,1.713A1.71,1.71,0,0,0,5.3,13.709Z",
    transform: "translate(-14915.031 7077.183) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38136",
    "data-name": "Path 38136",
    d: "M4.532,3.85c0-.961.008-1.92,0-2.879A.938.938,0,1,0,2.653.958c-.005.881-.008,1.762,0,2.643a.286.286,0,0,1-.227.334A3.571,3.571,0,0,0,2.415,10.7a.306.306,0,0,1,.241.355q-.009,4.479,0,8.959a.937.937,0,0,0,1.255.962.957.957,0,0,0,.624-.966q0-2.423,0-4.846c0-1.371,0-2.741,0-4.112a.291.291,0,0,1,.226-.337,3.576,3.576,0,0,0-.022-6.78C4.671,3.908,4.609,3.88,4.532,3.85ZM5.3,7.322a1.714,1.714,0,1,1-1.72-1.713A1.71,1.71,0,0,1,5.3,7.322Z",
    transform: "translate(-14915.031 7086.647) rotate(-90)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/Filter.5b64fd9e.svg";
export { ForwardRef as ReactComponent };